import { Field, Form, Formik } from 'formik'
import PropTypes from 'prop-types'
import { LuLoaderCircle } from 'react-icons/lu'
import { Link } from 'wouter'
import * as Yup from 'yup'

export default function RequestResetForm({
  showGuide,
  error,
  requestedReset,
  handleSubmit
}) {
  // Esquema de validación del formulario
  const validationSchema = Yup.object().shape({
    email: Yup.string().email('Correo inválido').required('Introduce un correo')
  })

  return (
    <>
      {!showGuide ? (
        <Formik
          initialValues={{
            email: ''
          }}
          validationSchema={validationSchema}
          onSubmit={(values) => {
            handleSubmit(values)
          }}
        >
          {({ errors, touched }) => (
            <Form className="px-4 py-3">
              <h3 className="mt-5 text-xl font-medium text-center text-gray-600 dark:text-gray-200">
                ¿Ha olvidado su contraseña?
              </h3>

              <p className="mt-1 text-center text-gray-500 dark:text-gray-400">
                Ingrese su correo para solicitar el restablecimiento de su
                contraseña
              </p>

              {/* Correo */}
              <div className="mt-8">
                <label
                  title="Correo"
                  htmlFor="email"
                  className={`${touched.email && errors.email ? 'text-red-700 dark:text-red-500' : 'text-gray-700 dark:text-gray-200'}`}
                >
                  Correo
                </label>

                <Field
                  id="email"
                  name="email"
                  type="email"
                  className={`block w-full p-2 mt-2 border bg-white rounded-sm focus:ring-opacity-40 focus:outline-none focus:ring ${touched.email && errors.email ? 'border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 dark:bg-gray-700 focus:border-red-500 dark:text-red-500 dark:placeholder-red-500 dark:border-red-500' : ' text-gray-700 border-gray-200 dark:bg-gray-800 dark:text-gray-300 dark:border-gray-600 focus:border-blue-400 focus:ring-blue-300 dark:focus:border-blue-300'}`}
                  autoComplete="new-password"
                  placeholder="example@example.com"
                  tabIndex="0"
                />

                <div
                  className={`flex justify-start items-start w-full ${touched.email && errors.email ? 'visible' : 'invisible'}`}
                >
                  <div className="flex w-full">
                    <p className="mt-1 text-sm leading-none text-red-600">
                      {errors.email || '\u00A0'}
                    </p>
                  </div>
                </div>
              </div>

              <div className="flex flex-col items-center justify-center w-full mt-5 space-y-4">
                <button
                  title={requestedReset.loading ? 'Solicitando' : 'Solicitar'}
                  type="submit"
                  className="flex items-center justify-center w-full px-5 py-2 text-white capitalize transition-colors duration-200 border rounded-sm bg-accent border-accent gap-x-2 enabled:hover:bg-white enabled:hover:text-accent dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:enabled:hover:bg-gray-800 disabled:opacity-30 focus:ring-opacity-20 focus:outline-none focus:ring focus:ring-accent focus:border-accent dark:focus:border-accent"
                  tabIndex="1"
                  disabled={requestedReset.loading}
                >
                  <LuLoaderCircle
                    className={`animate-spin ${requestedReset.loading ? 'block' : 'hidden'}`}
                    size={24}
                  />
                  {requestedReset.loading ? 'Solicitando' : 'Solicitar'}
                </button>

                <Link
                  title="Cancelar"
                  href={`/login`}
                  className="text-sm text-gray-400 focus:text-blue-500 hover:text-blue-500 hover:underline"
                >
                  Cancelar
                </Link>
              </div>

              <div
                className={`relative text-sm px-2 py-1 mt-2 text-red-600 bg-red-100 border border-red-600 rounded-sm ${error ? 'visible' : 'invisible'}`}
                role="alert"
              >
                <strong className="font-bold">Error: </strong>
                <span className="block sm:inline">{error}</span>
              </div>
            </Form>
          )}
        </Formik>
      ) : (
        <div className="px-4 pt-3 pb-4">
          <div>
            <h1 className="text-lg font-semibold text-gray-800 dark:text-white">
              Pasos a seguir
            </h1>

            <div className="mt-2 text-gray-600 dark:text-gray-300">
              <p>
                Recibirá un correo con un enlace para restablecer su contraseña:
              </p>

              <ol className="pt-2 pb-6 pl-6 list-decimal">
                <li>Abra el correo.</li>
                <li>Pulse sobre el enlace.</li>
                <li>Establezca una nueva contraseña.</li>
                <li>Inicie sesión nuevamente.</li>
              </ol>

              <p>
                El enlace es de un solo uso y caduca en{' '}
                <span className="font-semibold text-red-500 animate-pulse">
                  15 minutos
                </span>
                . Si expira, solicite uno nuevo.
              </p>
            </div>
          </div>

          <div className="flex items-center justify-center mt-8">
            <Link
              title="Aceptar"
              href={`/login`}
              className="flex items-center justify-center w-full px-5 py-2 text-white capitalize transition-colors duration-200 border rounded-sm bg-accent border-accent gap-x-2 hover:bg-white hover:text-accent dark:bg-gray-900 dark:text-gray-200 dark:border-gray-700 dark:hover:bg-gray-800 focus:ring-opacity-20 focus:outline-none focus:ring focus:ring-accent focus:border-accent dark:focus:border-accent"
            >
              Aceptar
            </Link>
          </div>
        </div>
      )}
    </>
  )
}

RequestResetForm.propTypes = {
  showGuide: PropTypes.bool,
  error: PropTypes.any,
  requestedReset: PropTypes.any,
  handleSubmit: PropTypes.func
}
